module.exports = __webpack_public_path__ + "static/media/how_it_works_wash_and_fold_icon.57bc8ee2.png";